import React from "react"
import PropTypes from "prop-types"
import { Tabs, theme } from "antd"


const DrawerTabs = ({ items }) => {
  const { token: { colorBgContainer } } = theme.useToken()

  const tabBarStyle = {
    marginLeft: -24,
    paddingLeft: 24,
    marginRight: -24,
    paddingRight: 24,
    backgroundColor: colorBgContainer,
  }

  return (
    <Tabs
      size="small"
      items={items}
      tabBarStyle={tabBarStyle}
    />
  )
}

DrawerTabs.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape()).isRequired,
}

export default DrawerTabs
